import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation resources
import enTranslation from "./locales/en/translation.json";
import ruTranslation from "./locales/ru/translation.json";
import kkCyrillicTranslation from "./locales/kk/translation.json";
import kkLatinTranslation from "./locales/kk-latn/translation.json";

export enum Language {
  ENGLISH = "en",
  RUSSIAN = "ru",
  KAZAKH_CYRILLIC = "kk",
  KAZAKH_LATIN = "kk-latn",
}

// Language names for display in the UI
export const languageNames = {
  [Language.ENGLISH]: "English",
  [Language.RUSSIAN]: "Русский",
  [Language.KAZAKH_CYRILLIC]: "Қазақша",
  [Language.KAZAKH_LATIN]: "Qazaqsha",
};

// Initialize i18next
i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources: {
      [Language.ENGLISH]: {
        translation: enTranslation,
      },
      [Language.RUSSIAN]: {
        translation: ruTranslation,
      },
      [Language.KAZAKH_CYRILLIC]: {
        translation: kkCyrillicTranslation,
      },
      [Language.KAZAKH_LATIN]: {
        translation: kkLatinTranslation,
      },
    },
    fallbackLng: {
      "kk-latn": ["kk-latn", "en"],
      default: [Language.KAZAKH_CYRILLIC],
    },
    debug: true, // Enable debug mode to see what's happening with language detection

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ["navigator"],
    },

    // Manually whitelist the languages to ensure they are valid options
    supportedLngs: [...Object.values(Language), "kk-Latn"],

    // Don't use these options as they may interfere with language detection
    cleanCode: false,
    load: "all",

    // Set default language to Kazakh Cyrillic
    lng: Language.KAZAKH_CYRILLIC,

    // Handle case sensitivity issues
    lowerCaseLng: true,
  });

// Add a language change listener
i18n.on("languageChanged", (lng) => {
  // Update HTML lang attribute to help browsers
  const htmlLang = lng.split("-")[0]; // Get the base language code
  document.documentElement.setAttribute("lang", htmlLang);
});

export default i18n;
